import React from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { Translation } from 'react-i18next';
import centredForm from '../components/centredForm';

const styles = (theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    maxWidth: 350,
  },
  button: {
    marginTop: theme.spacing(2),
    backgroundColor: '#357a38',
    color: '#ffffff',
    fontWeight: '600',
  },
  registratonText: {
    color: '#4CAF50',
    fontWeight: 'bold',
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f50057',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

function ConfirmRegistration(props) {
  const { classes } = props;

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <Typography
              variant="h5"
              className={classes.registratonText}
              align="center"
            >
              {t('successfulRegistration')}
            </Typography>
            <Typography align="center" variant="h5">
              {t('activationtEmailSent')}
            </Typography>
            <MuiThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={classes.button}
                component={Link}
                to={'/login'}
                fullWidth
              >
                {t('continue')}
              </Button>
            </MuiThemeProvider>
          </div>
        );
      }}
    </Translation>
  );
}

ConfirmRegistration.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(centredForm, withStyles(styles))(ConfirmRegistration);



// WEBPACK FOOTER //
// ./src/view/scenes/Registration/ConfirmRegistration.js